const isTrustedExternalUrl = (url: string, trustedBaseUrls: (string | undefined)[]): boolean => {
  try {
    const { hostname } = new URL(url);
    return trustedBaseUrls.some((base) => {
      if (!base) return false;
      try {
        return new URL(base).hostname === hostname;
      } catch {
        return false;
      }
    });
  } catch {
    return false;
  }
};

export { isTrustedExternalUrl };
